export default class ConditionalToggle {
    constructor() {
        this.toggle = document.querySelector('.conditional-toggle');

        if (!this.toggle) {
            return;
        }

        this.toggle.addEventListener('change', this.toggleField.bind(this));
    }

    toggleField(e) {
        e.stopPropagation();
        e.preventDefault();

        const conditionalElements = document.querySelectorAll('.conditional');
        const targetInput = this.toggle.getElementsByTagName('input')[0];

        if (targetInput.checked) {
            conditionalElements.forEach((element) => {
                element.classList.remove('collapse');
            });

            return;
        }

        conditionalElements.forEach((element) => {
            element.classList.add('collapse');
        });
    }
}
